/**
 * @fileoverview Feriados nacionais do Brasil de um ano, calculados aqui (sem API
 * externa): as datas fixas das Leis 662/1949, 6.802/1980 e 14.759/2023 e as que
 * dependem da Páscoa. Carnaval, Páscoa e Corpus Christi vêm como facultativos:
 * na lei são ponto facultativo e muita empresa abre nesses dias.
 */

const DAY_MS = 24 * 60 * 60 * 1000;
const pad = (n) => String(n).padStart(2, "0");
const isoDate = (date) => `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`;

/** Domingo de Páscoa no calendário gregoriano (algoritmo de Meeus/Jones/Butcher). */
export const easterSunday = (year) => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const n = h + l - 7 * m + 114;
  return new Date(Date.UTC(year, Math.floor(n / 31) - 1, (n % 31) + 1));
};

const FIXED = [
  ["01-01", "newYear"],
  ["04-21", "tiradentes"],
  ["05-01", "labourDay"],
  ["09-07", "independence"],
  ["10-12", "aparecida"],
  ["11-02", "allSouls"],
  ["11-15", "republic"],
  ["11-20", "blackConsciousness"],
  ["12-25", "christmas"],
];

// [dias a partir do domingo de Páscoa, nome, facultativo]
const FROM_EASTER = [
  [-48, "carnivalMonday", true],
  [-47, "carnivalTuesday", true],
  [-2, "goodFriday", false],
  [0, "easter", true],
  [60, "corpusChristi", true],
];

/** [{ date: "AAAA-MM-DD", key, optional }] do ano, em ordem de data. */
export const nationalHolidays = (year) => {
  const easter = easterSunday(year).getTime();
  return [
    ...FIXED.map(([monthDay, key]) => ({ date: `${year}-${monthDay}`, key, optional: false })),
    ...FROM_EASTER.map(([days, key, optional]) => ({ date: isoDate(new Date(easter + days * DAY_MS)), key, optional })),
  ].sort((x, y) => x.date.localeCompare(y.date));
};
